import { ReactElement } from 'react';
import { AccessLevelModel } from 'shared/domain/issue/mapping/accessLevel/model/types';
import { AccessLevelOnDropdownView } from 'shared/domain/issue/mapping/accessLevel/toOnView/types';
import { LabelledUser } from 'shared/domain/user/mapping/toView';
import { ManagementSelect } from '../select';
import { AccessManagementColumn } from '../types';
import { StyledTableRow } from './tableRow';
import { UserTranslationKeys } from 'intl/keys';

export const accessLevelColumn: AccessManagementColumn = {
  id: 'accessLevel',
  label: UserTranslationKeys.managementPermission,
  style: { minWidth: '100px' },
};

export function AccessRow({
  user,
  accessLevelOnDropdownView,
  onAccessChange,
}: {
  user: LabelledUser;
  accessLevelOnDropdownView: AccessLevelOnDropdownView;
  onAccessChange: (
    newAccessLevel: AccessLevelModel,
    currentAccessLevel: AccessLevelModel,
    userId: string,
    userLabel: string
  ) => void;
}): ReactElement {
  const { disabled, disabledReasons, value, explanationLabel } =
    accessLevelOnDropdownView;
  return (
    <StyledTableRow key={accessLevelColumn.id}>
      <ManagementSelect
        disabled={disabled}
        disabledReasons={disabledReasons}
        userId={user._id}
        userLabel={user.label}
        userRole={user.role}
        currentAccess={value}
        onChange={onAccessChange}
        explanationLabel={explanationLabel}
      />
    </StyledTableRow>
  );
}
